import API from './api';

export default class NetworkUserApi {
  static getList(params) {
    return API.get('/advertisers/network_users', params);
  }

  static create(params) {
    return API.post('/advertisers/network_users', params);
  }

  static update(id, params) {
    return API.put(`/advertisers/network_users/${id}`, params);
  }

  static delete(id, params) {
    return API.delete(`/advertisers/network_users/${id}`, params);
  }
}
